import React, { useEffect, useState } from "react";

import { Checkbox, ListItemText, MenuItem } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { SelectItemProps } from "../CustomHubSelctBox";

interface CustomHubMenuItemsInterface {
  classes: any;
  customCountryRecord?: any;
  items: { [key: string]: Array<SelectItemProps> };
  multiple?: boolean;
  searchText: string;
  handleDdnChange: any;
  ddnValue: any;
}

const CustomHubMenuItems = (props: CustomHubMenuItemsInterface) => {
  const { classes, customCountryRecord, items, multiple, searchText, handleDdnChange, ddnValue } = props;

  const [isOpenStates, setIsOpenStates] = useState<any>({});

  let checker = (arr: any, target: any) => arr.every((v: any) => target.includes(v.value));

  const handleExpandClick = (key: string) => {
    setIsOpenStates((prevStates: any) => ({ ...prevStates, [key]: !prevStates[key] }));
  };

  const getCountryName = (key: string): string => {
    if (customCountryRecord?.length > 0) {
      const country = customCountryRecord.find((countryObject: any) => countryObject.value === key);
      return country ? `${country.name} (All)` : `${key} (All)`;
    }
    return `${key} (All)`;
  };

  const containsText = (text: any, searchText: any) => {
    return text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
  };

  const displayedOptions = (record: SelectItemProps[]) => {
    return record && Array.isArray(record) ? record.filter((option) => containsText(option.value, searchText) || containsText(option.name, searchText)) : [];
  };

  const getMenuItems = (key: string) => {
    let result: any = items[key] && items[key]?.length > 0 ? items[key] : [];
    result = searchText && items && Object.keys(items)?.length > 0 ? displayedOptions(items[key]) : items[key];
    return result && result.length
      ? result.map((item: any, itemIndex: number) => (
          <MenuItem key={`${key}-${item.value}-${itemIndex}`} value={item.value} className={classes.customMenuPropsList} onClick={(event: any) => handleDdnChange(event, key, item.value)}>
            <>
              {multiple && <Checkbox size="small" color="primary" checked={ddnValue.indexOf(item.value) > -1} />}
              <ListItemText primary={`${item.value} - ${item.name}`} />
            </>
          </MenuItem>
        ))
      : null;
  };

  useEffect(() => {
    if (searchText !== '') {
      const newOpenStates = {} as any;
      Object.keys(items).forEach((key) => {
        newOpenStates[key] = true;
      });
      setIsOpenStates(newOpenStates);
    }
    else{
      const newOpenStates = {} as any;
      Object.keys(items).forEach((key) => {
        newOpenStates[key] = false;
      });
      setIsOpenStates(newOpenStates);
    }
  }, [searchText, items]);

  return (
    <>
      {items &&
        Object.keys(items)?.length > 0 &&
        Object.keys(items).map((key: string, index: number) => (
          <>
            <MenuItem key={`${key}-${index}`} value={key} onClick={() => handleExpandClick(key)}>
              <>
                {multiple && <Checkbox size="small" color="primary" checked={items[key]?.length > 0 && checker(items[key], ddnValue)} onClick={(event: any) => handleDdnChange(event, key)} disabled={searchText !== ''} />}
                <ListItemText primary={getCountryName(key)} />
                <ExpandMoreIcon />
              </>
            </MenuItem>
            {isOpenStates[key] && getMenuItems(key)}
          </>
        ))}
    </>
  );
};

export default React.memo(CustomHubMenuItems);
